var map = {
	"./_collections": "./src/js/svgoCustom/plugins/_collections.js",
	"./_collections.js": "./src/js/svgoCustom/plugins/_collections.js",
	"./_path": "./src/js/svgoCustom/plugins/_path.js",
	"./_path.js": "./src/js/svgoCustom/plugins/_path.js",
	"./_transforms": "./src/js/svgoCustom/plugins/_transforms.js",
	"./_transforms.js": "./src/js/svgoCustom/plugins/_transforms.js",
	"./addAttributesToSVGElement": "./src/js/svgoCustom/plugins/addAttributesToSVGElement.js",
	"./addAttributesToSVGElement.js": "./src/js/svgoCustom/plugins/addAttributesToSVGElement.js",
	"./addClassesToSVGElement": "./src/js/svgoCustom/plugins/addClassesToSVGElement.js",
	"./addClassesToSVGElement.js": "./src/js/svgoCustom/plugins/addClassesToSVGElement.js",
	"./cleanupAttrs": "./src/js/svgoCustom/plugins/cleanupAttrs.js",
	"./cleanupAttrs.js": "./src/js/svgoCustom/plugins/cleanupAttrs.js",
	"./cleanupEnableBackground": "./src/js/svgoCustom/plugins/cleanupEnableBackground.js",
	"./cleanupEnableBackground.js": "./src/js/svgoCustom/plugins/cleanupEnableBackground.js",
	"./cleanupIDs": "./src/js/svgoCustom/plugins/cleanupIDs.js",
	"./cleanupIDs.js": "./src/js/svgoCustom/plugins/cleanupIDs.js",
	"./cleanupListOfValues": "./src/js/svgoCustom/plugins/cleanupListOfValues.js",
	"./cleanupListOfValues.js": "./src/js/svgoCustom/plugins/cleanupListOfValues.js",
	"./cleanupNumericValues": "./src/js/svgoCustom/plugins/cleanupNumericValues.js",
	"./cleanupNumericValues.js": "./src/js/svgoCustom/plugins/cleanupNumericValues.js",
	"./collapseGroups": "./src/js/svgoCustom/plugins/collapseGroups.js",
	"./collapseGroups.js": "./src/js/svgoCustom/plugins/collapseGroups.js",
	"./convertColors": "./src/js/svgoCustom/plugins/convertColors.js",
	"./convertColors.js": "./src/js/svgoCustom/plugins/convertColors.js",
	"./convertEllipseToCircle": "./src/js/svgoCustom/plugins/convertEllipseToCircle.js",
	"./convertEllipseToCircle.js": "./src/js/svgoCustom/plugins/convertEllipseToCircle.js",
	"./convertPathData": "./src/js/svgoCustom/plugins/convertPathData.js",
	"./convertPathData.js": "./src/js/svgoCustom/plugins/convertPathData.js",
	"./convertShapeToPath": "./src/js/svgoCustom/plugins/convertShapeToPath.js",
	"./convertShapeToPath.js": "./src/js/svgoCustom/plugins/convertShapeToPath.js",
	"./convertStyleToAttrs": "./src/js/svgoCustom/plugins/convertStyleToAttrs.js",
	"./convertStyleToAttrs.js": "./src/js/svgoCustom/plugins/convertStyleToAttrs.js",
	"./convertTransform": "./src/js/svgoCustom/plugins/convertTransform.js",
	"./convertTransform.js": "./src/js/svgoCustom/plugins/convertTransform.js",
	"./inlineStyles": "./src/js/svgoCustom/plugins/inlineStyles.js",
	"./inlineStyles.js": "./src/js/svgoCustom/plugins/inlineStyles.js",
	"./mergePaths": "./src/js/svgoCustom/plugins/mergePaths.js",
	"./mergePaths.js": "./src/js/svgoCustom/plugins/mergePaths.js",
	"./minifyStyles": "./src/js/svgoCustom/plugins/minifyStyles.js",
	"./minifyStyles.js": "./src/js/svgoCustom/plugins/minifyStyles.js",
	"./moveElemsAttrsToGroup": "./src/js/svgoCustom/plugins/moveElemsAttrsToGroup.js",
	"./moveElemsAttrsToGroup.js": "./src/js/svgoCustom/plugins/moveElemsAttrsToGroup.js",
	"./moveGroupAttrsToElems": "./src/js/svgoCustom/plugins/moveGroupAttrsToElems.js",
	"./moveGroupAttrsToElems.js": "./src/js/svgoCustom/plugins/moveGroupAttrsToElems.js",
	"./prefixIds": "./src/js/svgoCustom/plugins/prefixIds.js",
	"./prefixIds.js": "./src/js/svgoCustom/plugins/prefixIds.js",
	"./removeAttributesBySelector": "./src/js/svgoCustom/plugins/removeAttributesBySelector.js",
	"./removeAttributesBySelector.js": "./src/js/svgoCustom/plugins/removeAttributesBySelector.js",
	"./removeAttrs": "./src/js/svgoCustom/plugins/removeAttrs.js",
	"./removeAttrs.js": "./src/js/svgoCustom/plugins/removeAttrs.js",
	"./removeComments": "./src/js/svgoCustom/plugins/removeComments.js",
	"./removeComments.js": "./src/js/svgoCustom/plugins/removeComments.js",
	"./removeDesc": "./src/js/svgoCustom/plugins/removeDesc.js",
	"./removeDesc.js": "./src/js/svgoCustom/plugins/removeDesc.js",
	"./removeDimensions": "./src/js/svgoCustom/plugins/removeDimensions.js",
	"./removeDimensions.js": "./src/js/svgoCustom/plugins/removeDimensions.js",
	"./removeDoctype": "./src/js/svgoCustom/plugins/removeDoctype.js",
	"./removeDoctype.js": "./src/js/svgoCustom/plugins/removeDoctype.js",
	"./removeEditorsNSData": "./src/js/svgoCustom/plugins/removeEditorsNSData.js",
	"./removeEditorsNSData.js": "./src/js/svgoCustom/plugins/removeEditorsNSData.js",
	"./removeElementsByAttr": "./src/js/svgoCustom/plugins/removeElementsByAttr.js",
	"./removeElementsByAttr.js": "./src/js/svgoCustom/plugins/removeElementsByAttr.js",
	"./removeEmptyAttrs": "./src/js/svgoCustom/plugins/removeEmptyAttrs.js",
	"./removeEmptyAttrs.js": "./src/js/svgoCustom/plugins/removeEmptyAttrs.js",
	"./removeEmptyContainers": "./src/js/svgoCustom/plugins/removeEmptyContainers.js",
	"./removeEmptyContainers.js": "./src/js/svgoCustom/plugins/removeEmptyContainers.js",
	"./removeEmptyText": "./src/js/svgoCustom/plugins/removeEmptyText.js",
	"./removeEmptyText.js": "./src/js/svgoCustom/plugins/removeEmptyText.js",
	"./removeHiddenElems": "./src/js/svgoCustom/plugins/removeHiddenElems.js",
	"./removeHiddenElems.js": "./src/js/svgoCustom/plugins/removeHiddenElems.js",
	"./removeMetadata": "./src/js/svgoCustom/plugins/removeMetadata.js",
	"./removeMetadata.js": "./src/js/svgoCustom/plugins/removeMetadata.js",
	"./removeNonInheritableGroupAttrs": "./src/js/svgoCustom/plugins/removeNonInheritableGroupAttrs.js",
	"./removeNonInheritableGroupAttrs.js": "./src/js/svgoCustom/plugins/removeNonInheritableGroupAttrs.js",
	"./removeOffCanvasPaths": "./src/js/svgoCustom/plugins/removeOffCanvasPaths.js",
	"./removeOffCanvasPaths.js": "./src/js/svgoCustom/plugins/removeOffCanvasPaths.js",
	"./removeRasterImages": "./src/js/svgoCustom/plugins/removeRasterImages.js",
	"./removeRasterImages.js": "./src/js/svgoCustom/plugins/removeRasterImages.js",
	"./removeScriptElement": "./src/js/svgoCustom/plugins/removeScriptElement.js",
	"./removeScriptElement.js": "./src/js/svgoCustom/plugins/removeScriptElement.js",
	"./removeStyleElement": "./src/js/svgoCustom/plugins/removeStyleElement.js",
	"./removeStyleElement.js": "./src/js/svgoCustom/plugins/removeStyleElement.js",
	"./removeTitle": "./src/js/svgoCustom/plugins/removeTitle.js",
	"./removeTitle.js": "./src/js/svgoCustom/plugins/removeTitle.js",
	"./removeUnknownsAndDefaults": "./src/js/svgoCustom/plugins/removeUnknownsAndDefaults.js",
	"./removeUnknownsAndDefaults.js": "./src/js/svgoCustom/plugins/removeUnknownsAndDefaults.js",
	"./removeUnusedNS": "./src/js/svgoCustom/plugins/removeUnusedNS.js",
	"./removeUnusedNS.js": "./src/js/svgoCustom/plugins/removeUnusedNS.js",
	"./removeUselessDefs": "./src/js/svgoCustom/plugins/removeUselessDefs.js",
	"./removeUselessDefs.js": "./src/js/svgoCustom/plugins/removeUselessDefs.js",
	"./removeUselessStrokeAndFill": "./src/js/svgoCustom/plugins/removeUselessStrokeAndFill.js",
	"./removeUselessStrokeAndFill.js": "./src/js/svgoCustom/plugins/removeUselessStrokeAndFill.js",
	"./removeViewBox": "./src/js/svgoCustom/plugins/removeViewBox.js",
	"./removeViewBox.js": "./src/js/svgoCustom/plugins/removeViewBox.js",
	"./removeXMLNS": "./src/js/svgoCustom/plugins/removeXMLNS.js",
	"./removeXMLNS.js": "./src/js/svgoCustom/plugins/removeXMLNS.js",
	"./removeXMLProcInst": "./src/js/svgoCustom/plugins/removeXMLProcInst.js",
	"./removeXMLProcInst.js": "./src/js/svgoCustom/plugins/removeXMLProcInst.js",
	"./reusePaths": "./src/js/svgoCustom/plugins/reusePaths.js",
	"./reusePaths.js": "./src/js/svgoCustom/plugins/reusePaths.js",
	"./sortAttrs": "./src/js/svgoCustom/plugins/sortAttrs.js",
	"./sortAttrs.js": "./src/js/svgoCustom/plugins/sortAttrs.js",
	"./sortDefsChildren": "./src/js/svgoCustom/plugins/sortDefsChildren.js",
	"./sortDefsChildren.js": "./src/js/svgoCustom/plugins/sortDefsChildren.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/svgoCustom/plugins sync recursive ^\\.\\/.*$";